"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDraftActivateCampaignPreviewLinksQuery = exports.useGetActivateCampaignPreviewLinksQuery = exports.useGetActivateCampaignByIdQuery = exports.useGetDraftActivateCampaignByIdQuery = exports.activate = void 0;

var _EmptyAppApi = require("../../EmptyAppApi");

var activate = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getDraftActivateCampaignById: build.query({
        query: function query(_ref) {
          var draftId = _ref.draftId;
          return "/api/v1/campaigns/activate/drafts-v2/".concat(draftId);
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getActivateCampaignById: build.query({
        query: function query(_ref2) {
          var campaignId = _ref2.campaignId;
          return "/api/v1/campaigns/activate/campaigns/".concat(campaignId);
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getActivateCampaignPreviewLinks: build.query({
        query: function query(_ref3) {
          var campaignId = _ref3.campaignId;
          return "/api/v1/campaigns/activate/campaigns/".concat(campaignId, "/preview-links");
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getDraftActivateCampaignPreviewLinks: build.query({
        query: function query(_ref4) {
          var draftId = _ref4.draftId;
          return "/api/v1/campaigns/activate/drafts-v2/".concat(draftId, "/preview-links");
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      })
    };
  }
});

exports.activate = activate;
var useGetDraftActivateCampaignByIdQuery = activate.useGetDraftActivateCampaignByIdQuery,
    useGetActivateCampaignByIdQuery = activate.useGetActivateCampaignByIdQuery,
    useGetActivateCampaignPreviewLinksQuery = activate.useGetActivateCampaignPreviewLinksQuery,
    useGetDraftActivateCampaignPreviewLinksQuery = activate.useGetDraftActivateCampaignPreviewLinksQuery;
exports.useGetDraftActivateCampaignPreviewLinksQuery = useGetDraftActivateCampaignPreviewLinksQuery;
exports.useGetActivateCampaignPreviewLinksQuery = useGetActivateCampaignPreviewLinksQuery;
exports.useGetActivateCampaignByIdQuery = useGetActivateCampaignByIdQuery;
exports.useGetDraftActivateCampaignByIdQuery = useGetDraftActivateCampaignByIdQuery;